class RMC {
  constructor() {
    this.slide_controls = document.querySelector(".slide_controls");
    this.slide_prev = this.slide_controls.querySelector(".slide_prev");
    this.slide_next = this.slide_controls.querySelector(".slide_next");
    this.slide_current = this.slide_controls.querySelector(".slide_current");
    this.presentation_data = window.player_data;
    this.presentz = false;
    this.initPresentation();
    this.attachListeners();
  }

  attachListeners() {
    this.slide_prev.addEventListener("click", (e) => {
      e.preventDefault();
      dataLayer.push({
        event: "slideChange",
        slideDirection: "Previous",
        currentSlide: this.presentz.currentSlideIndex + 1,
      });
      this.presentz.previous();
    });
    this.slide_next.addEventListener("click", (e) => {
      e.preventDefault();
      dataLayer.push({
        event: "slideChange",
        slideDirection: "Next",
        currentSlide: this.presentz.currentSlideIndex + 1,
      });
      this.presentz.next();
    });
  }

  initPresentation(resource) {
    let _this = this;
    this.presentz = new Presentz("#player", "960x540", "#slideshow", "960x540");
    this.presentz.init(this.presentation_data);
    this.presentz.on("slidechange", (prevChap, prevSlide, chap, slide) => {
      _this.slide_current.innerHTML = slide + 1;
      _this.slide_prev.disabled = slide === 0;
      _this.slide_next.disabled = _this.getSlideCount() - 1 === slide;
      dataLayer.push({
        event: "viewSlide",
        slideNumber: slide + 1,
        talkTitle: _this.presentation_data.title,
      });
    });
    this.presentz.changeChapter(0, 0, true, function (err) {
      if (err) {
        alert(err);
      }
    });
  }

  getSlideCount() {
    return this.presentation_data.chapters[0].slides.length;
  }
}

class EAPaywall {
  constructor() {
    this.paywall = document.querySelector(".paywall");
    this.paywallform = this.paywall.querySelector("#email-check");
    this.error_msg = this.paywall.querySelector(".error_msg");
    if (window.localStorage.getItem("ea_attendee") !== "true") {
      this.attachListeners();
      this.openPaywall();
    }
  }

  attachListeners() {
    this.paywallform.addEventListener("submit", (e) => {
      e.preventDefault();
      if (this.paywallform.email.value.length) {
        this.hideError();
        let $request = window.jQuery.ajax({
          url: window.resources.ajax_url,
          type: "post",
          data: {
            action: "check_ea_email",
            email: this.paywallform.email.value,
          },
        });

        $request.success((response) => {
          let $json = JSON.parse(response);
          console.log($json.attendee);
          if ($json.attendee) {
            this.closePaywall();
          } else {
            this.showError();
          }
        });
      }
    });
  }

  showError() {
    this.error_msg.classList.add("show");
  }

  hideError() {
    this.error_msg.classList.remove("show");
  }

  openPaywall() {
    document.body.classList.add("show-paywall");
  }

  closePaywall() {
    document.body.classList.remove("show-paywall");
    window.localStorage.setItem("ea_attendee", true);
  }
}

window.addEventListener("load", () => {
  if (window.gate_content) {
    window.$EAPaywall = new EAPaywall();
  }
  window.$RMC = new RMC();
});
